module.exports = __webpack_public_path__ + "static/media/icon_close_x.5d70f7dd.png";